<template>
  <div
    class="grid h-max flex-1 grid-cols-4 gap-6 max-lg:grid-cols-4 max-lg:gap-4"
    :class="[displayListView ? 'max-sm:grid-cols-1' : 'max-sm:grid-cols-2']"
  >
    <product-card-skeleton v-for="i in itemsPerPage" :key="i" />
  </div>
</template>

<script setup lang="ts">
import { CatalogView } from "../../user-settings/types";

const props = defineProps<{
  itemsPerPage: number;
  listView?: boolean;
}>();

const { catalogViewType } = useUserSettings();

const displayListView = computed(
  () => props.listView ?? catalogViewType.value === CatalogView.list,
);
</script>
